// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Material UI
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';

// Import Pages
import LibraryItem from '../LibraryItem/LibraryItem';

// Import CSS
import '../ModuleItem/ModuleItem.css';
import { quickActionsAtom, baseOrigin } from '../../../../../../recoil-store/recoil-state';
import { useSetRecoilState, useRecoilValue } from 'recoil';

const defaultLibraryImg = `default_library.png`

const ScopeLibraryItem = ({
    library,
    handleDragStart,
    handleDragEnd,
    isDesktopRecorder,
    // baseOrigin,
    libraryExpand,
    openAddActionsByClickDialog,
}) => {
    const { t } = useTranslation();

    const [expand, setExpand] = useState(false);
    const setQuickActions = useSetRecoilState(quickActionsAtom);
    const base_origin = useRecoilValue(baseOrigin);

    useEffect(() => {
        if (libraryExpand) {
            setExpand(libraryExpand)
            return
        }
        setExpand(false)
    }, [libraryExpand])
    useEffect(() => {
        if (library.library_name === "DESKTOP-ACTIONS") {
            let newLibrary = JSON.parse(JSON.stringify(library))
            setQuickActions(newLibrary)
        }
    }, [])
    return (
        (library.visible || library.library_name === "DESKTOP-ACTIONS") &&
        <>
            <div className="library-item-container font-manrope">
                <div className="library-item-padding">
                    <div className="ml-item-header library-item-header">
                        <div className="module-item-title-container" >
                            <img loading="lazy" src={library.image?.includes('data:') ? library.image :
                                `${base_origin}/libraries/${library.is_system ? "system" : "custom"}/${library.image ? library.image : defaultLibraryImg}`} className="library-img" />
                            <span className="module-item-title">{library.library_label.includes('CUSTOM') ? library.library_name :
                                t("CONTENT.LIBRARY." + library.library_name + ".NAME")}</span>
                        </div>
                        {expand ? <KeyboardArrowUp className="module-item-expand" onClick={() => setExpand(false)} /> : <KeyboardArrowDown className="module-item-expand" onClick={() => setExpand(true)} />}
                    </div>
                </div>
            </div >

            {
                expand &&
                <div className="module-item-content">


                    <LibraryItem img={library.image?.includes('data:') ? library.image :
                        `${base_origin}/libraries/${library.is_system ? "system" : "custom"}/${library.image ? library.image : defaultLibraryImg}`}
                        name={library.library_label.includes('CUSTOM') ? library.library_name :
                            t("CONTENT.LIBRARY." + library.library_name + ".NAME")}
                        actions={library.library_versions[library.library_versions.length - 1].actions
                            ?
                            library.library_versions[library.library_versions.length - 1].actions :
                            []}
                        library={library}
                        handleDragStart={handleDragStart}
                        handleDragEnd={handleDragEnd}
                        isDesktopRecorder={isDesktopRecorder}
                        openAddActionsByClickDialog={openAddActionsByClickDialog} />

                </div>
            }
            {library.library_name === "DESKTOP-ACTIONS" ? <div style={{ textAlign: "center" }}> <p>--Or--</p></div> : ""}
        </>

    )
}

export default ScopeLibraryItem;